var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	13325: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	74125: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	93586: {
		fallback: () => (__webpack_require__.e(69).then(() => (() => (__webpack_require__(87069))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.20.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",
	},
	91602: {
		fallback: () => (__webpack_require__.e(162).then(() => (() => (__webpack_require__(45162))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.6.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "print-js",
	},
	7333: {
		fallback: () => (Promise.all([__webpack_require__.e(220), __webpack_require__.e(325)]).then(() => (() => (__webpack_require__(75220))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.1.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-router",
	},
	21055: {
		fallback: () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(21036))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.9.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/telemetry",
	},
	22938: {
		fallback: () => (__webpack_require__.e(612).then(() => (() => (__webpack_require__(7612))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.14.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/hardware",
	},
	25291: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.38",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	33755: {
		fallback: () => (__webpack_require__.e(667).then(() => (() => (__webpack_require__(13667))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.7.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/auth",
	},
	73834: {
		fallback: () => (__webpack_require__.e(21).then(() => (() => (__webpack_require__(31021))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.5.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-axios",
	},
	90837: {
		fallback: () => (Promise.all([__webpack_require__.e(124), __webpack_require__.e(125)]).then(() => (() => (__webpack_require__(82124))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "4.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vuex",
	},
	40674: {
		fallback: () => (__webpack_require__.e(353).then(() => (() => (__webpack_require__(74353))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.11.10",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "dayjs",
	},
	8329: {
		fallback: () => (__webpack_require__.e(676).then(() => (() => (__webpack_require__(23676))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^8.0.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@microsoft/signalr",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"125": [
		74125
	],
	"281": [
		40674
	],
	"325": [
		13325
	],
	"342": [
		7333,
		21055,
		22938,
		25291,
		33755,
		73834,
		90837
	],
	"397": [
		8329
	],
	"586": [
		93586
	],
	"611": [
		91602
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}